import { useMutation } from 'react-query';
import { controlBackdropLoading, inventoryService, removeCache } from '../../services';
import { ImageObjType } from '../../types';

export const useCompleteEmployeeInventoryMutation = () => {
  return useMutation(
    ({ id }: any) => {
      return inventoryService.complete({ id });
    },
    {
      onSuccess: () => {
        removeCache(['inventory', 'key']);
      },
    },
  );
};

export const useItemCheckInventoryMutation = () => {
  return useMutation(({ id, ...props }: any) => {
    if (!props.containerId) delete props.containerId;

    return inventoryService.itemCheck({ id, ...props });
  });
};

export const useItemUploadImagesMutation = () => {
  return useMutation(
    ({ id, photos = [] }: { id: string; photos: ImageObjType[] }) => {
      controlBackdropLoading(1);

      return inventoryService.itemUploadImages({ id, photos }).then((res: any) => {
        let images = [];
        if (typeof res === 'object') images = res.data.data;

        return images;
      });
    },
    {
      onSettled: () => {
        removeCache(['inventory', 'key']);
        controlBackdropLoading(-1);
      },
    },
  );
};
